import React from "react";
import {useSelector, shallowEqual } from "react-redux";
import {
  fetchConsignmentHistoryAndProducts,
  closeDialog,
  resetReplanningSuccess,
  updateAddressSuccess,
  fetchCHDSlotDropdownValues,
  updateCustomerAddress,
} from "./redux/carrefourDeliverySlice";

import OrderDetails from "../SharedComponent/components/orderDetailComponent"
import CarrefourDeliveryOrderDetailsEdit from "./CarrefourDeliveryOrderDetailsEdit";
import { AppState } from "../config/redux/reducers";
import {
  getAddressInfo,
  getLatLong,
  createPayloadForUpdatingCustAddress,
} from "mocks/carrefourHomeDelivery/response.transforms";
import { pdfjs } from "react-pdf";
import UpdatePartialRejection from "./UpdatePartialRejection";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface CarrefourDeliveryOrderDetailsProps {
  open: boolean;
  consignment: any;
  isFromViewRoute?: any;
  isEditIcon?: any;
  closePopup: () => void;
}

const CarrefourDeliveryOrderDetails = (props: CarrefourDeliveryOrderDetailsProps) => {
  const { open, consignment, isFromViewRoute, isEditIcon, closePopup } = props;

  const {
    consignmentStatuses,
    productsList,
    consignmentDataAfterReplanning,
    isUpdateAddress,
    updatedCustomerAddress,
  } = useSelector((state: AppState) => state.carrefourDelivery, shallowEqual);

  return (
    <OrderDetails
      open={open}
      consignment={consignment}
      isFromViewRoute={isFromViewRoute}
      isEditIcon={isEditIcon}
      closePopup={closePopup}
      reduxState={{
        consignmentStatuses,  
        productsList,
        consignmentDataAfterReplanning,
        isUpdateAddress,
        updatedCustomerAddress,
      }}
      transform={{
        getAddressInfo, 
        getLatLong,
        createPayloadForUpdatingCustAddress,
      }}
      actions={{
        fetchConsignmentHistoryAndProducts,
        closeDialog,
        resetReplanningSuccess,
        updateAddressSuccess,
        fetchSlotDropdownValues: fetchCHDSlotDropdownValues,
        updateCustomerAddress,
      }}
      OrderDetailsEdit={CarrefourDeliveryOrderDetailsEdit}
      UpdatePartialRejection = {UpdatePartialRejection}
    />
   
  );
};

export default CarrefourDeliveryOrderDetails;
